var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 9.66667L8.00016 7M8.00016 7L10.6668 9.66667M8.00016 7V13M13.3335 10.1619C14.1478 9.48936 14.6668 8.47196 14.6668 7.33333C14.6668 5.30829 13.0252 3.66667 11.0002 3.66667C10.8545 3.66667 10.7182 3.59066 10.6442 3.46516C9.77487 1.98989 8.16978 1 6.3335 1C3.57207 1 1.3335 3.23858 1.3335 6C1.3335 7.3774 1.89046 8.62472 2.79146 9.52902",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadGray);
export default __webpack_public_path__ + "static/media/upload_gray.31ddbd34cf484f75e0a6b136be1cb22e.svg";
export { ForwardRef as ReactComponent };